@if (open) {
  <div class="pw-overlay">
    <div
      class="pw-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="pw-title"
      aria-describedby="pw-body"
    >
      <div class="pw-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="4" y="11" width="16" height="10" rx="2" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
      </div>

      <h2 id="pw-title" class="pw-title" dir="auto">{{ 'passwordPromptTitle' | translate }}</h2>
      <p id="pw-body" class="pw-body" dir="auto">{{ 'passwordPromptBody' | translate }}</p>
      <app-password-deadline [deadline]="deadline"></app-password-deadline>

      <app-password-form #form (saved)="completed.emit()" (continued)="deferred.emit()">
        @if (snoozeError) {
          <p pwMessage class="pw-error" role="alert" dir="auto">{{ 'announcementSnoozeFailed' | translate }}</p>
        }
        @if (canSnooze && !form.notAvailable) {
          <button pwAction type="button" class="pw-btn pw-btn--ghost" (click)="notNow()" [disabled]="form.busy">
            {{ snoozesLeft === null ? ('announcementNotNow' | translate) : ('announcementNotNowLeft' | translate: { left: snoozesLeft }) }}
          </button>
        }
      </app-password-form>
    </div>
  </div>
}
